module.exports = __webpack_public_path__ + "static/media/3.295605bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/slides/3.png
// module id = 640
// module chunks = 0